import { TableField, defaultCurrencyFormatter } from "../../table-field";

export const fieldsParticipanteContrato: TableField[] = [
  {
    key: "TldParticipante",
    label: "País",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
  },
  {
    key: "CdCpfCnpjParticipante",
    label: "CPF/CNPJ/Doc.",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
  },
  {
    key: "NmParticipante",
    label: "Nome/Razão Social",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
  },
  {
    key: "FlConsorcio",
    label: "Consórcio",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
    formatter: (value: string) => value === "S" ? "Sim" : "Não" 
  },
  {
    key: "VlParticipacao",
    label: "Valor",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
    formatter: defaultCurrencyFormatter
  },
];

export const fieldEdicaoParticipanteContrato: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};
